import axios from 'axios';

const log = require("loglevel").getLogger("OpportunityService");
log.setLevel("error");

export const loadOpportunityPicklists = id => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/opportunity/get/picklists`)
		.then(async response => {
			const res = response.data.data;
			log.debug("OpportunityService -> loadOpportunityPicklists -> return");
			return res;
		})
		.catch(response => {
			log.debug("OpportunityService -> loadOpportunityPicklists -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadOpportunityById = id => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/opportunity/get/id`, {id})
		.then(async response => {
			const res = response.data.data;
			log.debug("OpportunityService -> loadOpportunityById -> return");
			return res;
		})
		.catch(response => {
			log.debug("OpportunityService -> loadOpportunityById -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadOpportunities = (selectedFilters, forceReload) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/opportunity/get`, {selectedFilters, forceReload: forceReload === true})
		.then(async response => {
			const res = response.data;
			log.debug("OpportunityService -> loadOpportunities -> return");
			return res;
		})
		.catch(response => {
			log.debug("OpportunityService -> loadOpportunities -> error: ");
			log.debug(response);
			return null;
		});
};

export const saveOpportunity = (opportunityId, updatedFields, selectedVendor) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/opportunity`, {opportunityId, updatedFields, selectedVendor})
		.then(async response => {
			const res = response.data;
			log.debug("OpportunityService -> saveOpportunity -> return");
			return res;
		})
		.catch(response => {
			log.debug("OpportunityService -> saveOpportunity -> error: ");
			log.debug(response);
			return null;
		});
};

export const createOpportunity = (updatedFields) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/opportunity`, {opportunityId: '-1', updatedFields})
		.then(async response => {
			const res = response.data;
			log.debug("OpportunityService -> createOpportunity -> return");
			return res;
		})
		.catch(response => {
			log.debug("OpportunityService -> createOpportunity -> error: ");
			log.debug(response);
			return null;
		});
};
